import { isOneOfTags } from 'anodum';
import {
  BLOCK_ELEMENTS,
  LIST_ELEMENTS,
  LIST_ITEM,
  TABLE_ELEMENTS,
} from '../constants/editable-elements';

const getBlockFirstChildElement = (element) => {
  if (!element.firstElementChild) return null;

  if (isOneOfTags(element.firstElementChild, BLOCK_ELEMENTS)) {
    return element.firstElementChild;
  }

  if (isOneOfTags(element.firstElementChild, [...LIST_ELEMENTS, LIST_ITEM, ...TABLE_ELEMENTS])) {
    return getBlockFirstChildElement(element.firstElementChild);
  }

  return null;
};

export default getBlockFirstChildElement;
